import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import HeaderAndFooterLine from './HeaderAndFooterLine';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  display: flex;
  pointer-events: none;
`;

const getLabelSize = (title, description, min = 60, max = 100) => {
  const reference = (!description || title.length > description?.length) ? title : description;
  const size = reference.length * 10;
  return Math.min(Math.max(size, min), max);
};

export default function HeaderAndFooter ({ header, footer } = {}) {
  const size = getLabelSize(header.label, header.description);

  return (
    <Wrapper>
      <HeaderAndFooterLine
        x1={header.x}
        x2={header.x + header.width + size}
        y1={header.y}
        y2={header.y}
        isActive={header.isActive}
        label={{
          size,
          position: 'bottom',
          label: header.label,
          description: header.description,
          onClick: header.onClick
        }}
      />

      <HeaderAndFooterLine
        x1={footer.x}
        x2={header.x + footer.width + size}
        y1={footer.y}
        y2={footer.y}
        isActive={footer.isActive}
        label={{
          size,
          position: 'top',
          label: footer.label,
          description: footer.description,
          onClick: footer.onClick
        }}
      />
    </Wrapper>
  );
}

HeaderAndFooter.propTypes = {
  header: PropTypes.exact({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    onClick: PropTypes.func
  }),
  footer: PropTypes.exact({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    isActive: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    description: PropTypes.string,
    onClick: PropTypes.func
  })
};
